import { defineMessages } from "react-intl";

export const productVariantAvailabilityCardMessages = defineMessages({
  title: {
    id: "YixcQ/",
    defaultMessage: "Purchasability per variant",
    description: "ProductVariantAvailabilityCard title",
  },
  subtitle: {
    id: "qqDN3Z",
    defaultMessage:
      "Control which variants can be purchased in each channel. A variant stays visible but cannot be bought when turned off. Publishing is set for the whole product above.",
    description: "ProductVariantAvailabilityCard subtitle",
  },
  availableForPurchase: {
    id: "ZFQ+jv",
    defaultMessage: "Available for purchase",
    description: "ProductVariantAvailabilityCard variant purchasable label",
  },
  noVariants: {
    id: "qtL82a",
    defaultMessage: "No priced variants in this channel yet.",
    description: "ProductVariantAvailabilityCard empty channel",
  },
  updated: {
    id: "UHO3gQ",
    defaultMessage: "Variant purchasability updated",
    description: "ProductVariantAvailabilityCard success notification",
  },
});
